// import { toPng } from 'html-to-image'
import html2canvas from 'html2canvas';
import { sessionStorage } from '../../util';

function funcionImprimirEjercicio() {
  var childs = document.getElementsByClassName('contenidosVentana')[0].childNodes;
  var images = [];
  var nodosProcesados = 0;

  function addDataUrl(dataUrl, index) {
    images.push({
      index: index,
      dataUrl: dataUrl
    });
    nodosProcesados++;

    if (nodosProcesados === childs.length) {
      images.sort(function (a, b) {
        return a.index - b.index;
      });
      var data = {
        images: images
      };
      sessionStorage.setItem('imprimirEjercicio', JSON.stringify(data));
      var url = encodeURI('printEjercicio.html');
      window.open(url, '_blank');
      setCursor('default');
    }
  }

  function setCursor(cursor) {
    document.body.style.cursor = cursor;
    var iframes = document.getElementsByTagName('iframe');

    for (var i = 0; i < iframes.length; i++) {
      iframes[i].contentDocument.body.style.cursor = cursor;
    }
  }

  setCursor('wait');
  childs.forEach(function (child, index) {
    var node = child.tagName !== 'IFRAME' ? child : child.contentDocument.getElementById('ebody');

    var _node$getBoundingClie = node.getBoundingClientRect(),
        width = _node$getBoundingClie.width,
        height = _node$getBoundingClie.height;

    html2canvas(node, {
      logging: false,
      backgroundColor: null,
      width: width,
      height: height,
      windowWidth: width,
      windowHeight: height
    }).then(function (canvas) {
      return addDataUrl(canvas.toDataURL('image/png', 1), index);
    });
  });
}

export default funcionImprimirEjercicio;